import { createBrowserRouter } from 'react-router';
import { EstadoError } from '@xiltrion/ui/bloques/estados';
import { AppShell } from './AppShell';
import { ActivateAccount, ResetPassword } from '@/pages/auth/Cuenta';
import { Portada } from '@/pages/auth/Portada';
import { Interaction } from '@/pages/auth/Interaction';
import { Home } from '@/pages/home/Home';
import { NotificationsPage } from '@/pages/notifications/NotificationsPage';
import { Profile } from '@/pages/profile/Profile';
import { EntityPage } from '@/pages/entities/EntityPage';
import { EntitiesAdmin } from '@/pages/admin/EntitiesAdmin';
import { AppsAdmin } from '@/pages/admin/AppsAdmin';
import { UsersAdmin } from '@/pages/admin/UsersAdmin';
import { AuditAdmin } from '@/pages/admin/AuditAdmin';
import { MailAdmin } from '@/pages/admin/MailAdmin';
import { BackupsAdmin } from '@/pages/admin/BackupsAdmin';

export function buildRouter() {
  return createBrowserRouter([
    { path: '/ingreso', element: <Portada /> },
    { path: '/restablecer-clave', element: <ResetPassword /> },
    { path: '/activar-cuenta', element: <ActivateAccount /> },
    { path: '/interaccion/:uid', element: <Interaction /> },
    {
      path: '/',
      element: <AppShell />,
      children: [
        { index: true, element: <Home /> },
        { path: 'avisos', element: <NotificationsPage /> },
        { path: 'perfil', element: <Profile /> },
        { path: 'entidades/:slug', element: <EntityPage /> },
        { path: 'admin/entidades', element: <EntitiesAdmin /> },
        { path: 'admin/apps', element: <AppsAdmin /> },
        { path: 'admin/usuarios', element: <UsersAdmin /> },
        { path: 'admin/auditoria', element: <AuditAdmin /> },
        { path: 'admin/correo', element: <MailAdmin /> },
        { path: 'admin/respaldos', element: <BackupsAdmin /> },
        { path: '*', element: <div className="p-6"><EstadoError titulo="Esta página no existe." /></div> },
      ],
    },
  ]);
}
